import { MapPin, Phone, Mail, Clock } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ConsultationForm from "@/components/ConsultationForm";
import SEO from "@/components/SEO";
import { useLanguage } from "@/hooks/useLanguage";
import { organizationSchema } from "@/lib/seo-schemas";

const Contact = () => {
  const { t } = useLanguage();

  return (
    <>
      <SEO 
        title={t('contact.title')}
        description={t('contact.subtitle')}
        keywords="contact lawyer Houston, immigration attorney contact, legal consultation Houston"
        schema={organizationSchema}
      />
      <div className="min-h-screen flex flex-col bg-background">
        <Header />
        
        <main className="flex-1">
          {/* Hero Section */}
          <section className="relative py-20 bg-gradient-hero text-primary-foreground">
            <div className="container mx-auto px-4">
              <div className="max-w-4xl mx-auto text-center">
                <h1 className="text-4xl md:text-5xl font-bold mb-6">{t('contact.title')}</h1>
                <p className="text-xl opacity-95">
                  {t('contact.subtitle')}
                </p>
              </div>
            </div>
          </section>

          {/* Contact Section */}
          <section className="py-20 bg-background">
            <div className="container mx-auto px-4">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
                {/* Contact Info */}
                <div>
                  <h2 className="text-3xl font-bold mb-8">{t('contact.getintouch')}</h2>
                  
                  <div className="space-y-6 mb-8">
                    <div className="flex items-start gap-4">
                      <div className="bg-primary/10 p-3 rounded-lg">
                        <MapPin className="h-6 w-6 text-primary" />
                      </div>
                      <div>
                        <h3 className="font-bold mb-1">{t('contact.office')}</h3>
                        <p className="text-muted-foreground">
                          10925 Beechnut St A106<br />
                          Houston, TX 77072
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="bg-primary/10 p-3 rounded-lg">
                        <Phone className="h-6 w-6 text-primary" />
                      </div>
                      <div>
                        <h3 className="font-bold mb-1">{t('contact.phone')}</h3>
                        <p className="text-muted-foreground">
                          <strong>ENGLISH:</strong> <a href="tel:8329303059" className="text-primary hover:underline">(832) 930-3059</a><br />
                          <strong>ESPAÑOL:</strong> <a href="tel:8323567254" className="text-primary hover:underline">(832) 356-7254</a><br />
                          <strong>TIẾNG VIỆT:</strong> <a href="tel:8329303059" className="text-primary hover:underline">(832) 930-3059</a>
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="bg-primary/10 p-3 rounded-lg">
                        <Mail className="h-6 w-6 text-primary" />
                      </div>
                      <div>
                        <h3 className="font-bold mb-1">{t('contact.email')}</h3>
                        <p className="text-muted-foreground">
                          <a href="mailto:info@danielalbertlaw.com" className="text-primary hover:underline">
                            info@danielalbertlaw.com
                          </a>
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="bg-primary/10 p-3 rounded-lg">
                        <Clock className="h-6 w-6 text-primary" />
                      </div>
                      <div>
                        <h3 className="font-bold mb-1">{t('contact.hours')}</h3>
                        <p className="text-muted-foreground">
                          {t('contact.hours.mon')}<br />
                          {t('contact.hours.closed')}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Map */}
                  <div className="rounded-lg overflow-hidden shadow-lg">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3466.1234567890123!2d-95.54321098765432!3d29.69876543210987!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c3d1234567890%3A0xabcdef1234567890!2s10925%20Beechnut%20St%20A106%2C%20Houston%2C%20TX%2077072!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
                      width="100%"
                      height="300"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Daniel Albert Law Firm Office Location"
                    />
                  </div>
                </div>

                {/* Contact Form */}
                <div>
                  <ConsultationForm />
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Contact;
